import { render, staticRenderFns } from "./week.vue?vue&type=template&id=24af01af&scoped=true&"
import script from "./week.vue?vue&type=script&lang=js&"
export * from "./week.vue?vue&type=script&lang=js&"
import style0 from "./week.vue?vue&type=style&index=0&id=24af01af&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24af01af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24af01af')) {
      api.createRecord('24af01af', component.options)
    } else {
      api.reload('24af01af', component.options)
    }
    module.hot.accept("./week.vue?vue&type=template&id=24af01af&scoped=true&", function () {
      api.rerender('24af01af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecg/JEasyCron/tabs/week.vue"
export default component.exports